import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { ProgressBarContainer, Bar } from './ProgressBar-styled'

function getPercentageAchieved({ target, achieved }) {
  const percent = Math.round((achieved / target) * 100)
  if (percent < 0) {
    return 0
  }
  if (percent > 100) {
    return 100
  }
  return percent
}

class ProgressBar extends Component {
  state = {
    // set the split lengths to zero if we are to animate them on entry
    zeroSplits: !!this.props.animateOnEntry,
  }
  componentDidMount() {
    // remove zero split state after mount, to set actual split values
    // which will prompt a CSS animation
    // TODO: this is not good REPLACE ME!!!!
    if (this.props.animateOnEntry) {
      setTimeout(() => {
        this.setState({
          zeroSplits: false,
        })
      }, 100)
    }
  }

  render() {
    const {
      target,
      achieved,
      height,
      width,
      targetColor,
      achievedColor,
      split,
      animateSeconds,
    } = this.props
    const { zeroSplits } = this.state

    let barSplit = []
    // if no split is provided then creat a dummy split with just the one provided item
    if (!split) {
      barSplit.push({ achieved, achievedColor })
    } else {
      barSplit = [...split]
    }

    return (
      <ProgressBarContainer height={height} width={width} targetColor={targetColor}>
        {barSplit.map((bar, index) => {
          const { achieved, achievedColor } = bar
          let thisAchieved = achieved
          if (zeroSplits) {
            thisAchieved = 0
          }
          const percentageAchieved = getPercentageAchieved({ target, achieved: thisAchieved })
          return (
            <Bar
              key={index}
              height={height}
              achievedColor={achievedColor}
              percentageAchieved={percentageAchieved}
              animateSeconds={animateSeconds}
            />
          )
        })}
      </ProgressBarContainer>
    )
  }
}

ProgressBar.propTypes = {
  target: PropTypes.number.isRequired,
  achieved: PropTypes.number,
  height: PropTypes.string,
  width: PropTypes.string,
  targetColor: PropTypes.string,
  achievedColor: PropTypes.string,
  split: PropTypes.arrayOf(
    PropTypes.shape({
      achieved: PropTypes.number,
      achievedColor: PropTypes.string,
    }),
  ),
  animateOnEntry: PropTypes.bool,
  animateSeconds: PropTypes.string,
}

ProgressBar.defaultProps = {
  height: '20px',
  width: '100%',
  targetColor: '#cccaca',
  achievedColor: '#41a541',
  animateOnEntry: false,
  animateSeconds: '1s',
}

export default ProgressBar



// WEBPACK FOOTER //
// ./src/component/_presentational/ProgressBar/ProgressBar.jsx